import { captureException } from '@sentry/nextjs';
import { withErrorBoundary } from '@buzzfeed/react-components';
import { usePageviewTracking } from '../../hooks/analytics/usePageviewTracking';
import { useTimeSpentTracking } from '../../hooks/analytics/useTimeSpentTracking';
import { useScrollDepthTracking } from '../../hooks/analytics/useScrollDepthTracking';
import { usePerformanceTracking } from '../../hooks/analytics/usePerformanceTracking';
import { useLocalBuzzTracking } from '../../utils/localBuzzTracking';
import { useSessionTracking } from '../../hooks/useSessionTracking';
import useTrackonomics from '@buzzfeed/react-components/lib/hooks/useTackonomics';

const InfiniteScrollTracking = withErrorBoundary(
  ({ buzz = {} }) => {
    usePageviewTracking(buzz);
    useTimeSpentTracking(buzz);
    useScrollDepthTracking(buzz);
    usePerformanceTracking(buzz);
    useLocalBuzzTracking(buzz.id);
    useSessionTracking(buzz.id);
    useTrackonomics(buzz.id);
    return null;
  },
  { onError: captureException }
);

export default InfiniteScrollTracking;
